// extracted by mini-css-extract-plugin
module.exports = {"summary_card":"SummaryCardComponent_summary_card__2HgD9","label_text":"SummaryCardComponent_label_text__3hxrl","value_text":"SummaryCardComponent_value_text__3dS8a"};